const SEO = [
	{
		page: "home",
		description:
			"I'm a full-stack developer passionate about building scalable web applications using React, Spring Boot, and PostgreSQL. I enjoy creating efficient, maintainable, and user-friendly solutions.",
		keywords: [
			"Anh Viet Doan",
			"Full-Stack Developer",
			"React",
			"Spring Boot",
			"PostgreSQL",
		],
	},

	{
		page: "skill",
		description:
			"Learn more about my skills, technologies I use, and proficiency across languages and tools.",
		keywords: [
			"Anh Viet Doan",
			"Skills",
			"Full-Stack Developer",
			"Portfolio",
		],
	},

	{
		page: "articles",
		description:
			"A collection of my thoughts, tutorials, and insights on full-stack development, microservices, and software engineering best practices.",
		keywords: [
			"Articles",
			"Full-Stack Development",
			"React",
			"Spring Boot",
			"Microservices",
		],
	},

	{
		page: "projects",
		description:
			"Showcase of my full-stack projects including web applications, open-source contributions, and deployed apps using React and Spring Boot.",
		keywords: [
			"Projects",
			"React",
			"Spring Boot",
			"Full-Stack Applications",
			"Portfolio",
		],
	},

	{
		page: "experience",
		description:
			"Professional work experience, roles, and accomplishments across software engineering positions.",
		keywords: [
			"Work Experience",
			"Software Engineer",
			"Resume",
			"Career",
			"Portfolio",
		],
	},

	{
		page: "contact",
		description:
			"Get in touch to collaborate on web development projects, internships, or open-source contributions. I'm always open to exciting opportunities.",
		keywords: [
			"Contact",
			"Anh Viet Doan",
			"Full-Stack Developer",
			"Collaboration",
			"Portfolio",
		],
	},
];

export default SEO;
